"use strict";

function escapeHtml(value) {
    return String(value === undefined || value === null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
}

function addCsrfToken(data) {
    var requestData = data || {};
    var $csrfToken = $(".tracking-consent[data-tokenName][data-token]").first();
    var tokenName = $csrfToken.attr("data-tokenName");
    var token = $csrfToken.attr("data-token");

    if (!tokenName || !token) {
        var $csrfInput = $("input[name*='csrf_token']").first();
        tokenName = $csrfInput.attr("name");
        token = $csrfInput.val();
    }

    if (tokenName && token) {
        requestData[tokenName] = token;
    }

    return requestData;
}

function setRemovalLoadingState($modal, isLoading) {
    $modal.find(".js-btn-accept-stock, .js-btn-change-location").prop("disabled", isLoading);
}

function showRemovalError($modal) {
    $modal.find(".js-stock-removal-error").removeClass("d-none");
}

function isRemovalEnabled($modal) {
    return $modal.data("removal-enabled") === true;
}

function removeUnavailableProducts($modal) {
    var removeProductsUrl = $modal.data("remove-products-url");
    var unavailableProductUUIDs = $modal.data("unavailable-product-uuids") || [];

    if (!removeProductsUrl || unavailableProductUUIDs.length === 0) {
        showRemovalError($modal);
        return;
    }

    setRemovalLoadingState($modal, true);
    $modal.find(".js-stock-removal-error").addClass("d-none");

    $.ajax({
        url: removeProductsUrl,
        type: "post",
        data: addCsrfToken({
            uuids: JSON.stringify(unavailableProductUUIDs)
        }),
        dataType: "json",
        success: function (data) {
            if (!data || data.error || !data.success) {
                setRemovalLoadingState($modal, false);
                showRemovalError($modal);
                return;
            }

            $modal.modal("hide");

            var cartUrl = $("#checkout-main").data("cart-url");
            if (data.remainingItemCount === 0 && cartUrl) {
                window.location.href = cartUrl;
                return;
            }

            window.location.reload();
        },
        error: function () {
            setRemovalLoadingState($modal, false);
            showRemovalError($modal);
        }
    });
}

/**
 * Applies one of the three modal states (spec 5.3): partial (can remove), all unavailable,
 * or no data. Legacy wording is left untouched when removal is disabled by the toggle.
 * @param {jQuery} $modal - modal root
 * @param {Object} data - CheckStoreAvailability payload
 */
function applyModalState($modal, data) {
    if (!isRemovalEnabled($modal)) {
        return;
    }

    var $title = $modal.find(".js-stock-modal-title");
    var $description = $modal.find(".js-stock-modal-description");
    var $accept = $modal.find(".js-btn-accept-stock");
    var $change = $modal.find(".js-btn-change-location");

    if (data.canRemove) {
        $title.text($modal.data("title-partial"));
        $description.text($modal.data("description-partial"));
        $accept.removeClass("d-none");
        $change.text($modal.data("change-location-label"));
        return;
    }

    $title.text($modal.data("title-unavailable"));
    $description.text(data.allProductsUnavailable
        ? $modal.data("description-all-unavailable")
        : $modal.data("description-no-stores"));
    $accept.addClass("d-none");
    $change.text($modal.data("change-location-only-label"));
}

function showStockAvailabilityModal(data) {
    var $modal = $(".js-cart-stock-availability-modal");
    if (!$modal.length) return;

    var payload = data || {};

    if (payload.currentLocation) {
        $("#stock-modal-commune").text(payload.currentLocation.commune || "");
        $("#stock-modal-region").text(payload.currentLocation.region || "");
    }

    var $productsList = $("#stock-modal-products-list").empty();
    var articleLabel = $modal.data("article-label") || "Articulo";
    var availableQuantityLabel = $modal.data("available-quantity-label") || "Cantidad Disponible:";
    var unitsLabel = $modal.data("units-label") || "Unidades";
    var fallbackImageUrl = $modal.data("no-image-url") || "";

    var unavailableProductUUIDs = [];
    (payload.products || []).forEach(function (product) {
        if (product.uuid) {
            unavailableProductUUIDs.push(product.uuid);
        }

        var stockClass = product.availableStock === 0 ? "no-stock" : "";
        var imageUrl = product.imageUrl || fallbackImageUrl;
        var imageOnError = fallbackImageUrl
            ? "this.onerror=null;this.src='" + fallbackImageUrl + "';"
            : "this.style.display='none';";
        var safeName = escapeHtml(product.productName || "");
        var productHtml = "<div class=\"product-item\" data-uuid=\"" + escapeHtml(product.uuid || "") + "\">"
            + "<p class=\"product-label\">" + escapeHtml(articleLabel) + "</p>"
            + "<div class=\"product-row\">"
            + "<div class=\"product-icon\"><img class=\"product-icon-img\" src=\"" + escapeHtml(imageUrl) + "\" alt=\"" + safeName + "\" onerror=\"" + escapeHtml(imageOnError) + "\" /></div>"
            + "<div class=\"stock-product-details\"><p class=\"product-name\">" + safeName + "</p></div>"
            + "</div>"
            + "<p class=\"product-stock " + stockClass + "\">"
            + escapeHtml(availableQuantityLabel) + " <span>" + escapeHtml(product.availableStock || 0) + " " + escapeHtml(unitsLabel) + "</span>"
            + "</p>"
            + "</div>";
        $productsList.append(productHtml);
    });

    $modal.data("unavailable-product-uuids", unavailableProductUUIDs);
    $modal.find(".js-stock-removal-error").addClass("d-none");
    setRemovalLoadingState($modal, false);
    applyModalState($modal, payload);
    // Um clique em "cambiar ubicación" durante o fade-in deixa o handler armado; limpar ao reabrir.
    $modal.off("hidden.bs.modal.stockZone");
    $modal.modal("show");
}

function openZoneSelector() {
    var isCheckoutContext = $("#checkout-main").length > 0;

    // No checkout reutilizamos o gatilho da própria página ("Cambiar de ubicación"): ele marca
    // data-trigger antes de abrir e trata o estado travado do Bootstrap (zoneSelector.js).
    var $checkoutTrigger = $(".js-btn-change-region-checkout");
    if (isCheckoutContext && $checkoutTrigger.length) {
        $checkoutTrigger.first().trigger("click");
        return;
    }

    // O seletor genérico do header posta em Stores-SaveZone e não limpa o estado de pickup
    // (selectedStoreID, fromStoreId) de que o checkout depende; no checkout, preferir o dele.
    var $regionModal = isCheckoutContext
        ? $(".js-region-selector-checkout-modal")
        : $(".js-region-selector-modal");
    if (!$regionModal.length) {
        $regionModal = $(".js-region-selector-modal");
    }
    if ($regionModal.length) {
        $regionModal.modal("show");
    }
}

function initStockAvailabilityModalListeners() {
    var $modal = $(".js-cart-stock-availability-modal");
    if (!$modal.length) return;

    $modal.find(".js-btn-accept-stock").on("click", function (e) {
        e.preventDefault();

        if (!isRemovalEnabled($modal)) {
            $modal.modal("hide");
            return;
        }

        removeUnavailableProducts($modal);
    });

    $modal.find(".js-btn-change-location").on("click", function (e) {
        e.preventDefault();

        // Encadeado em hidden.bs.modal, não em setTimeout: o Bootstrap não mostra um modal
        // enquanto o anterior ainda está fechando, e 300 ms não garantem o fim da transição.
        $modal.off("hidden.bs.modal.stockZone").one("hidden.bs.modal.stockZone", openZoneSelector);
        $modal.modal("hide");
    });
}

module.exports = {
    init: function () {
        initStockAvailabilityModalListeners();
    },
    showStockAvailabilityModal: showStockAvailabilityModal
};
